var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.83,19.11,13.24,3.58h0A1.4,1.4,0,0,0,12,2.85a1.43,1.43,0,0,0-1.25.73L2.17,19.11a1.33,1.33,0,0,0,0,1.35,1.44,1.44,0,0,0,1.23.69H20.58a1.45,1.45,0,0,0,1.23-.69A1.38,1.38,0,0,0,21.83,19.11ZM4.61,19,12,5.67,19.38,19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,16.5a.84.84,0,1,0,.84.84A.84.84,0,0,0,12,16.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.15,
    y: 9.76,
    width: 1.69,
    height: 5.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0f1a445e5ec39b5bafa7fb8639e967fe.svg";
export { ForwardRef as ReactComponent };